import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/styles'
import { resetDagState, setMasterApp } from '../../../../redux/actions/dagActions'
import { logoutUser } from '../../../../redux/actions/authActions'
import { Theme } from '../../../../utils/Theme'
import Header from '../../../layout/Partials/Header'
import AccessDenied from '../../../common/AccessDenied'
import Loading from '../../../common/Loading'
import TextFieldGroup from '../../../common/TextFieldGroup'
import { getQlikApps, getQlikStreams } from '../../../../redux/actions/qlikActions'
import SelectFieldGroup from '../../../common/SelectFieldGroup'
import AdminLayout from '../../../layout/AdminLayout'
import { withRouter } from 'react-router-dom'

const styles = Theme()

class CreateMasterApp extends Component {
  constructor(props) {
    super(props)
    const d = new Date()
    this.state = {
      //Form inputs
      title: '',
      stream: 'aaec8d41-5201-43ab-809f-3063750dfafd',
      namePrefix: 'Reload task for ',
      startDateTime: '',
      hour: d.getHours().toString(),
      minute: d.getMinutes().toString(),
      masterApp: {},
      qsApp: '',
      qsApps: [],
      qsStreams: [],
      qlikLoading: true,
      loading: true,
      errors: {},
      inputErrors: {},
    }
    this.onSubmit = this.onSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  componentDidMount() {
    this.props.getQlikApps()
    this.props.getQlikStreams()
  }

  componentWillUnmount() {
    this.props.resetDagState()
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let { qsApps, qlikLoading, qsStreams, inputErrors } = prevState

    if (nextProps.qlik.apps && nextProps.qlik.streams && !nextProps.qlik.loading) {
      qsApps = [] //Reset qs Apps to an Empty Array
      qsStreams = []

      nextProps.qlik.apps.forEach(app => {
        if (app.qMeta.published) {
          //Only show published Applications
          qsApps.push({ key: app.qDocId, title: app.qDocName })
        }
      })

      nextProps.qlik.streams.forEach(stream => {
        qsStreams.push({ key: stream.qId, title: stream.qName })
      })

      qlikLoading = false
    }

    if (!nextProps.dag.loading) {
      if (nextProps.dag.errors) {
        inputErrors = nextProps.dag.errors
      }
    }

    return { qsApps, qlikLoading, qsStreams, inputErrors }
  }

  onSubmit(event) {
    const d = new Date()
    event.preventDefault()
    const { qsApp, stream, title, namePrefix, hour, minute } = this.state
    const startDateTime = `${d.toLocaleDateString('en-gb', { year: 'numeric' })}-${d.toLocaleDateString('en-gb', {
      month: '2-digit',
    })}-${d.toLocaleDateString('en-gb', { day: '2-digit' })}T${hour}:${minute}:00.000`

    const masterApp = { qsApp, stream, title, namePrefix, startDateTime }

    this.props.setMasterApp(masterApp, this.props.history)
  }

  onChange(event) {
    this.setState({ [event.target.name]: event.target.value })
    if (event.target.name === 'qsApp') {
      const qsAppTitles = this.state.qsApps.filter(app => app.key === event.target.value)

      if (qsAppTitles.length > 0) {
        this.setState({ title: qsAppTitles[0].title })
      }
    }
  }

  render() {
    const { classes, auth, history } = this.props
    const { qsStreams, title, hour, minute, qsApps, qsApp, qlikLoading, stream, namePrefix, inputErrors } = this.state

    return (
      <AdminLayout>
        <div className="o-page">
          <Header>
            <h2 className="c-navbar__title">New Master App</h2>
          </Header>
          {auth.isAuthenticated && auth.user.role === 'Admin' ? (
            <div className="container">
              <div className={'row'}>
                <div className="col-md-12 col-xl-12 u-pr-zero u-pt-zero ">
                  <div className="col-md-12 col-sm-12 col-xl-12 u-mb-medium">
                    <div className="u-m-auto">
                      <div className="c-card u-p-zero u-m-zero">
                        <div className="o-line c-card__title u-p-small u-m-small">
                          <h4 className={`c-card__title ${classes.colorSecondary}`}>Create Master Application</h4>
                          <button
                            className={`c-btn ${classes.buttonSecondary}`}
                            onClick={() => {
                              this.props.history.goBack()
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                        <div className={'c-card__body u-pb-small'}>
                          {qlikLoading === true ? (
                            <div className={'u-text-center u-pb-medium'}>
                              <Loading />
                              <h5>Loading Qlik streams and applications, please wait...</h5>
                            </div>
                          ) : (
                            <form noValidate onSubmit={this.onSubmit} autoComplete={'none'}>
                              <div className={'row u-m-small'}>
                                <div className="col-6">
                                  {qsApps === null || qsApps.length <= 0 ? (
                                    <TextFieldGroup
                                      label={'Qlik Sense App'}
                                      onChange={this.onChange}
                                      value={qsApp}
                                      name={'qsApp'}
                                    />
                                  ) : (
                                    <SelectFieldGroup
                                      label={'Qlik Sense App'}
                                      type={'text'}
                                      onChange={this.onChange}
                                      value={qsApp}
                                      options={qsApps}
                                      name={'qsApp'}
                                      error={inputErrors.qsApp}
                                    />
                                  )}
                                </div>

                                <div className={'col-6'}>
                                  <TextFieldGroup
                                    label="Master App Title"
                                    type="text"
                                    onChange={this.onChange}
                                    value={title}
                                    name="title"
                                    placeholder="e.g. Sales"
                                    info={'Master App Title'}
                                    error={inputErrors.title}
                                  />
                                </div>

                                <div className={'c-divider col-12 u-mb-small u-mt-small'} />

                                <div className={'col-12'}>
                                  <h5>Dynamic Application Generation</h5>
                                </div>

                                <div className={'col-6'}>
                                  {qsStreams === null || qsStreams.length <= 0 ? (
                                    <TextFieldGroup
                                      label={'Stream'}
                                      onChange={this.onChange}
                                      value={stream}
                                      info={'Dynamic apps publish stream.'}
                                      name={'stream'}
                                    />
                                  ) : (
                                    <SelectFieldGroup
                                      label={'Stream'}
                                      type={'text'}
                                      onChange={this.onChange}
                                      value={stream || 'aaec8d41-5201-43ab-809f-3063750dfafd'}
                                      options={qsStreams}
                                      name={'stream'}
                                      info={'Dynamic apps publish stream'}
                                      error={inputErrors.stream}
                                    />
                                  )}
                                </div>
                                <div className={'col-6'}>
                                  <TextFieldGroup
                                    label="Reload task prefix"
                                    type="text"
                                    onChange={this.onChange}
                                    value={namePrefix || ''}
                                    name="namePrefix"
                                    placeholder="e.g. Reload task for "
                                    info={'Reload task prefix for D.A.G generated apps'}
                                    error={inputErrors.namePrefix}
                                  />
                                </div>
                                <div className={'col-12'}>
                                  <h6>Reload Task Start Time</h6>
                                </div>
                                <div className={'col-6'}>
                                  <TextFieldGroup
                                    label={'Hour'}
                                    type={'text'}
                                    onChange={this.onChange}
                                    value={hour}
                                    name={'hour'}
                                    info={'Dynamic applications reload time starting hour of the day'}
                                    error={inputErrors.hour}
                                  />
                                </div>

                                <div className={'col-6'}>
                                  <TextFieldGroup
                                    label={'Minute'}
                                    type={'text'}
                                    onChange={this.onChange}
                                    value={minute}
                                    name={'minute'}
                                    info={'Dynamic applications reload time starting minute of the hour'}
                                    error={inputErrors.minute}
                                  />
                                </div>

                                <div className={'col-12 u-mt-medium'}>
                                  <button className={`c-btn ${classes.buttonPrimary}`}>Create Master App</button>
                                </div>
                              </div>
                            </form>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <AccessDenied props={{ classes, history }} />
          )}
        </div>
      </AdminLayout>
    )
  }
}

CreateMasterApp.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  setMasterApp: PropTypes.func.isRequired,
  resetDagState: PropTypes.func.isRequired,
  getQlikApps: PropTypes.func.isRequired,
  getQlikStreams: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  classes: PropTypes.object,
  history: PropTypes.object,
  qlik: PropTypes.object,
  dag: PropTypes.object,
}

const mapStateToProps = state => ({
  auth: state.auth,
  qlik: state.qlik,
  dag: state.dag,
})

export default connect(mapStateToProps, {
  getQlikApps,
  resetDagState,
  getQlikStreams,
  logoutUser,
  setMasterApp,
})(withStyles(styles)(withRouter(CreateMasterApp)))
